export default __webpack_public_path__ + "static/media/google-shopping.ec1cc701.png";